import InvestigationAgentPage from 'components/AgentSessionPage';
import AgentSessionsPage from 'components/AgentSessionPage/AgentSessionsPage';
import InvestigationDetailPage from 'components/Investigations/InvestigationDetailPage';
import InvestigationsPage from 'components/Investigations/InvestigationsPage';
import { RouteSpec, SuperRouteSpec } from 'types';

const investigationsRoutes: (RouteSpec | SuperRouteSpec)[] = [
  {
    name: 'investigations-list',
    path: '/:customerDomain/investigations',
    component: InvestigationsPage,
    private: true,
    permissions: 'investigations.list',
    exact: true,
    data: {
      params: {
        order_desc: {
          defaultValue: 'true',
        },
        include_count: {
          defaultValue: '1',
        },
        investigations: {
          nestedResource: true,
          params: {
            limit: {
              defaultValue: '25',
            },
            offset: {
              defaultValue: '0',
            },
            broad_search: {},
            order_by: {
              defaultValue: 'updated_at',
              options: ['updated_at', 'created_at', 'name'],
            },
            order_desc: {
              defaultValue: 'true',
              options: ['true', 'false'],
            },
          },
        },
      },
    },
  },
  {
    name: 'investigation-detail',
    path: '/:customerDomain/investigations/:investigationId',
    component: InvestigationDetailPage,
    private: true,
    exact: true,
    permissions: 'investigations.retrieve',
    data: {
      params: {
        include_count: {
          defaultValue: '1',
        },
        investigation_envelopes: {
          nestedResource: true,
          params: {
            limit: {
              defaultValue: '25',
            },
            offset: {
              defaultValue: '0',
            },
            order_by: {
              defaultValue: 'updated_at',
              options: ['updated_at', 'created_at'],
            },
            order_desc: {
              defaultValue: 'true',
              options: ['true', 'false'],
            },
          },
        },
      },
    },
  },
  {
    name: 'agents-list',
    path: '/:customerDomain/investigations/:investigationId/agents/',
    component: AgentSessionsPage,
    private: true,
    permissions: 'investigations.agentSession',
    exact: true,
    data: {
      params: {
        order_desc: {
          defaultValue: 'true',
        },
        include_count: {
          defaultValue: '1',
        },
        agent_sessions: {
          nestedResource: true,
          params: {
            limit: {
              defaultValue: '25',
            },
            offset: {
              defaultValue: '0',
            },
            broad_search: {},
            order_by: {
              defaultValue: 'updated_at',
              options: ['updated_at', 'created_at', 'name'],
            },
            order_desc: {
              defaultValue: 'true',
              options: ['true', 'false'],
            },
          },
        },
      },
    },
  },
  {
    name: 'agent-chat',
    path: '/:customerDomain/investigations/:investigationId/agents/:agentId',
    component: InvestigationAgentPage,
    private: true,
    permissions: 'investigations.agentSession',
    exact: true,
  },
];

export default investigationsRoutes;
